module.exports = __webpack_public_path__ + "static/sc_4-61f9b054d1fadbb0a86814dfbf94d521.jpg";